import React from "react";
import { FaCheck } from "react-icons/fa";
import ReusableButton from "../../../components/reusable-button/ReusableButton";
import "./RequestForFreeExam.css";
import { useNavigate } from "react-router-dom";

const RequestReceived: React.FC = () => {
  const navigate = useNavigate();
  const CheckIcon = FaCheck as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;

  const handleButtonClick = (route: string) => {
    navigate(route);
  };

  return (
    <div className="request-container">
      <div className="request-box">
        <div className="check-icon-circle">
          <CheckIcon style={{ fontSize: 24 }} color="#ffffff" />
        </div>
        <h2 className="request-title">Free Exam Request Received</h2>
        <p className="request-subtext">
          Your request will be reviewed by the Washington State Library team.
        </p>
      </div>
      <p className="request-message">
        You will receive an email notification once your request has been
        processed. <br />
        This typically takes 3–5 business days.
      </p>
      <div className="button-group">
        <div className="button-wrapper">
          <ReusableButton
            label="Go to Dashboard"
            variant="outlined"
            onClick={() => handleButtonClick("/dashboard")}
          />
        </div>
        <div className="button-wrapper">
          <ReusableButton
            label="Submit Another Request"
            variant="primary"
            onClick={() => handleButtonClick("/request-for-free-exam")}
          />
        </div>
      </div>
    </div>
  );
};

export default RequestReceived;
